import { render, staticRenderFns } from "./ActiveVoip.vue?vue&type=template&id=71a82545&"
import script from "./ActiveVoip.vue?vue&type=script&lang=js&"
export * from "./ActiveVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports